import React from 'react';
import location from '../../images/contact/location.png';

const ContactEnd = () => {
  return (
    <section className='contact_end'>
      <div className='contact_end_address'>
        <span>Aaron
          <img src={location} />  
        </span> Technologies
        36, Mariamman Koil Street,
        Hasthampatty,
        Salem – 636 007.
        Tamil Nadu, INDIA.
      </div>
      <div className='contact_end_details'>
        <span>PHONE:</span> +91 427 4031707 / 4031909<br /><br />
        <span>MOBILE:</span> +91 99431 15155, 99435 43515<br /><br />
        <span>EMAIL:</span> info@aarontec.com
      </div>
    </section>
  )
}

export default ContactEnd
